class Extranet.Models.Hotel extends Extranet.Model

  urlRoot: '/extranet/api/hotels/'
  idAttribute: 'uuid'
  defaults:
    languageCode: 'en_US'